import moment from "moment/moment";
import ko from "knockout";
import numeral from "numeral";

export class ProfitabilityMetricsDailyModel {
    plannedHours: KnockoutComputed<string>;
    clockedHours: KnockoutComputed<string>;
    hours: KnockoutComputed<string>;
    labourProductivity: KnockoutComputed<string>;
    plannedLabourProductivity: KnockoutComputed<string>;
    productivity: KnockoutComputed<string>;
    date: KnockoutObservable<moment.Moment>;

    dailyCosts: KnockoutComputed<string>;
    clockedCosts: KnockoutComputed<string>;
    costs: KnockoutComputed<string>;

    formattedDailyCostsPercentage: KnockoutComputed<string>;
    calculatedCostsPercentage: KnockoutObservable<string>;
    dailyCostsPercentage: KnockoutObservable<number>;
    dailyCalculatedCostsPercentage: KnockoutObservable<number>;

    projectedRevenue: KnockoutComputed<string>;
    actualRevenue: KnockoutComputed<string>;
    revenue: KnockoutComputed<string>;

    showAllRevenueData: KnockoutObservable<boolean>;

    constructor(model: any = {}, showAllRevenueData: boolean) {
        this.showAllRevenueData = ko.observable(showAllRevenueData);
        this.date = ko.observable<moment.Moment>(model.date);

        this.dailyCosts = ko.pureComputed(() => numeral(model.dailyCosts).format('$0,0.00'));
        this.clockedCosts = ko.pureComputed(() => numeral(model.clockedCosts).format('$0,0.00'));
        this.costs = ko.pureComputed(() => `${this.dailyCosts()}/${this.clockedCosts()}`);

        this.formattedDailyCostsPercentage =
            ko.pureComputed(() => `${numeral(model.dailyCostsPercentage).format('0,0.00')}%`);
        this.calculatedCostsPercentage =
            ko.pureComputed(() => `${numeral(model.dailyCalculatedCostsPercentage).format('0,0.00')}%`);
        this.dailyCostsPercentage = ko.pureComputed(() => model.dailyCostsPercentage);
        this.dailyCalculatedCostsPercentage = ko.pureComputed(() => model.dailyCalculatedCostsPercentage);

        this.plannedHours = ko.pureComputed(() => `${model.plannedHours} uur`);
        this.clockedHours = ko.pureComputed(() => `${model.clockedHours} uur`);
        this.hours = ko.pureComputed(() => `${model.plannedHours}/${model.clockedHours} uur`);

        this.projectedRevenue = ko.pureComputed(() => numeral(model.projectedRevenue).format('$0,0.00'));
        this.actualRevenue = ko.pureComputed(() => numeral(model.actualRevenue).format('$0,0.00'));
        this.revenue = ko.pureComputed(() => `${this.projectedRevenue()}/${this.actualRevenue()}`);

        this.labourProductivity = ko.pureComputed(() => numeral(model.labourProductivity).format('$0,0.00'));
        this.plannedLabourProductivity = ko.pureComputed(() => numeral(model.plannedLabourProductivity).format('$0,0.00'));
        this.productivity = ko.pureComputed(() => `${this.plannedLabourProductivity()}/${this.labourProductivity()} p/u`);
    }
}
